import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1cd0904c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alarmMonitor"
};
import { reactive, ref } from "vue";
import data2 from './components/data2.vue';
import data1 from "./components/data1.vue";
import data3 from "./components/data3.vue";
import data4 from "./components/data4.vue";
export default {
  __name: 'index',
  setup(__props) {
    const state = reactive({
      activeName: "data1"
    });
    const tabClick = val => {};
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: state.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.activeName = $event),
        class: "alarmMonitor-tabs",
        onTabClick: tabClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "管网信息",
          name: "data1"
        }, {
          default: _withCtx(() => [state.activeName === 'data1' ? (_openBlock(), _createBlock(data1, {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "全景监测",
          name: "data2"
        }, {
          default: _withCtx(() => [state.activeName === 'data2' ? (_openBlock(), _createBlock(data2, {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "基础信息统计",
          name: "data3"
        }, {
          default: _withCtx(() => [state.activeName === 'data3' ? (_openBlock(), _createBlock(data3, {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "用户类型分析",
          name: "data4"
        }, {
          default: _withCtx(() => [state.activeName === 'data4' ? (_openBlock(), _createBlock(data4, {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};